import $ from 'jquery';
import _ from 'underscore';
import Storage from '@component/common/src/util/ClientSideStorage';
import Cookie from '@component/common/src/util/Cookie';
import Logger from '@component/common/src/util/Logger';

export default class List {
  static getAllProductFromList() {
    const self = this;
    const userGuid = Cookie.get('macys_online_guid');

    // Read the list for the User
    if (userGuid) {
      const url = `/xapi/wishlist/v1/${userGuid}/favorites`;
      $.ajax({
        type: 'GET',
        url,
        dataType: 'json',
        cache: false,
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      })
        .done((data) => {
          self.getAllListSuccesshandler(data);
        })
        .fail(() => {
          self.getAllListErrorhandler();
        });
    }
    // else {
    //   self.getItemsForList();
    // }
  }
  static getAllListSuccesshandler(dataObj) {
    try {
      if (dataObj && dataObj.list) {
        const { products, listGuid } = dataObj.list;
        if (products.length) {
          Storage.setSession('listItems', products.map(x => x.pid));
        }

        if (listGuid) {
          Storage.setSession('listGuid', listGuid);
        }
      }
    } catch (e) {
      Logger.error(e);
    }
  }
  static getAllListErrorhandler() {
    Logger.error('Unable to read from default list');
  }
  static getItemsForList() {
    const self = this;
    const listGuid = Storage.getSession('listGuid');
    if (listGuid) {
      const url = `/xapi/wishlist/v1/lists/${listGuid}?expand=items`;
      $.ajax({
        type: 'GET',
        url,
        dataType: 'json',
        cache: false,
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      })
        .done((data) => {
          self.readFromListSuccessHandler(data);
        })
        .fail(() => {
          self.readFromListErrorHandler();
        });
    }
  }
  static readFromListSuccessHandler(dataObj) {
    if (dataObj) {
      try {
        if (dataObj && dataObj.CustomerList && dataObj.CustomerList.list && dataObj.CustomerList.list.length > 0) {
          const defaultList = _.find(dataObj.CustomerList.list, list => list.defaultList === true);
          let productArray = [];
          if (defaultList && !_.isUndefined(defaultList.listGuid)) {
            Storage.setSession('listGuid', dataObj.CustomerList.list[0].listGuid);
          }
          if (defaultList && _.isArray(defaultList.items)) {
            productArray = _.map(dataObj.CustomerList.list[0].items, (item) => {
              if (item.upc && item.upc.product) {
                return item.upc.product.id;
              }
              if (item.product) {
                return item.product.id;
              }
              return '';
            });
          }
          Storage.setSession('listItems', productArray);
        }
      } catch (e) {
        Logger.error(e);
      }
    }
  }
  static readFromListErrorHandler() {
    Logger.error('Unable to read from default list');
  }

  // used from wishlist page
  static removeItemFromListStorage(productId) {
    const listItems = Storage.getSession('listItems');
    Storage.setSession('listItems', listItems.split(',').filter(v => v !== productId.toString()).join(','));
    const $target = $(`.pros-factory-carousel #${productId}`);
    if ($target.length > 0) {
      $target.find('.altContainer')
        .removeClass('icon-gen-heart-red-large')
        .addClass('icon-gen-heart-gr-large')
        .attr('title', 'Add To Default List');
    }
  }

  static updateHeart($thumbnailImg) {
    const productId = $thumbnailImg.closest('.productThumbnail').attr('id');
    const listItems = Storage.getSession('listItems');
    if (listItems && listItems.indexOf(productId) !== -1) {
      $thumbnailImg.find('.altContainer')
        .removeClass('icon-gen-heart-gr-large')
        .addClass('icon-gen-heart-red-large')
        .attr('title', 'Remove From Default List');
    }
  }
}
